import React from "react";
import { Link } from "react-router-dom";
import LogoutButton from "./LogoutButton.tsx";
import { useAuth } from "../context/AuthContext.tsx"; // Pokud používáte kontext pro autentizaci

const Header: React.FC = () => {
  const { currentUser } = useAuth();

  return (
    <header className="bg-gray-800 text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <h1 className="text-xl font-bold">Šachová aplikace</h1>
        </div>

        <div className="flex items-center gap-4">
          <Link
            to="/"
            className="px-4 py-2 rounded bg-white/10 hover:bg-white/20 transition-colors"
          >
            Zobrazit public verzi
          </Link>
          {currentUser && (
            <div className="flex items-center">
              <span className="mr-4">Přihlášen jako: {currentUser.email}</span>
              <LogoutButton />
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
